/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmdk_No_Documents_YetInputs */

const en_cmdk_no_documents_yet = /** @type {(inputs: Cmdk_No_Documents_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have no documents yet. Upload a file to get started.`)
};

const es_cmdk_no_documents_yet = /** @type {(inputs: Cmdk_No_Documents_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no tienes documentos. Sube un archivo para empezar.`)
};

/**
* | output |
* | --- |
* | "You have no documents yet. Upload a file to get started." |
*
* @param {Cmdk_No_Documents_YetInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cmdk_no_documents_yet = /** @type {((inputs?: Cmdk_No_Documents_YetInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmdk_No_Documents_YetInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_cmdk_no_documents_yet(inputs)
	return en_cmdk_no_documents_yet(inputs)
});